<!-- <mat-drawer mode="side" opened class="max-width patient-side-details">

        <app-patient-sidedetails [resolvedData]="resolvedData">

        </app-patient-sidedetails>
    </mat-drawer> -->
@if((auth.user | async)?.role == 'doctor' || (auth.user | async)?.role == 'primaryhealthcareprovider' || (auth.user | async)?.role == 'healthcareassistant' || (auth.user | async)?.role ==
'patient' || (auth.user | async)?.role == 'remotedoctor' || (auth.user | async)?.role == 'alliedhealthprofessional' || (auth.user | async)?.role == 'nursemidwife'
){
<!-- @if(!(isPatientAdmitted$ | async)){ -->
@if(true){
<div style="width: 100%; padding: 0px 20px; box-sizing: border-box;">
    <div class="" style="display: flex; width: 100%;
        box-sizing: border-box;
            justify-content: flex-start;">
        @if( patientDetailsStripService.patientDetailsStripStatus | async){
        <div class="side max-width">
            <app-patient-sidedetails [resolvedData]="resolvedData">

            </app-patient-sidedetails>
        </div>
        }
        <div class="main" style="flex: 1 1 auto; min-width: 0px;">
            <div class="tab-nav-outer" #tabOuter>
                <!-- Hidden measurement row (full set + More). Must be inside mat-tab-nav-bar for mat-tab-link. -->
                <nav mat-tab-nav-bar class="tab-nav-measure" aria-hidden="true">
                    @for (link of links; track link) {
                    <a mat-tab-link #measureLink>{{ getLinkLabel(link) | titlecase }}</a>
                    }
                    <a mat-tab-link #moreMeasure>More</a>
                </nav>

                <nav mat-tab-nav-bar [tabPanel]="tabPanel" mat-tab-align="center">
                    @for (link of visibleLinks; track link) {
                    <a [routerLink]="[link]" routerLinkActive="router-link-active" mat-tab-link
                        (click)="setActiveLink(link)" [active]="activeLink == link">
                        {{ getLinkLabel(link) | titlecase }}
                    </a>
                    }

                    @if((overflowLinks?.length ?? 0) > 0) {
                    <a mat-tab-link class="more-tab" [active]="isOverflowActive()" [matMenuTriggerFor]="moreTabsMenu">
                        More
                    </a>
                    <mat-menu #moreTabsMenu="matMenu">
                        @for (link of overflowLinks; track link) {
                        <a mat-menu-item [routerLink]="[link]" (click)="setActiveLink(link)">
                            {{ getLinkLabel(link) | titlecase }}
                        </a>
                        }
                    </mat-menu>
                    }
                </nav>
            </div>
            <mat-tab-nav-panel #tabPanel mat-tab-align="center">
                <div class="pt-20">
                    <router-outlet>

                    </router-outlet>
                </div>
                <!-- {{(auth.user | async) | json}} -->
                <!-- {{encounterState | async}} -->
                @if((auth.user | async)?.role === 'doctor' || (auth.user | async)?.role === 'primaryhealthcareprovider' ||
                (auth.user | async)?.role === 'healthcareassistant' || (auth.user | async)?.role === 'nursemidwife' ||
                (auth.user | async)?.role === 'remotedoctor' || (auth.user | async)?.role === 'alliedhealthprofessional'
                ){

                @if(!encounterContextLoading){

                @if(!(ecounterService.stateService.currentEncounter | async)?.status || (
                (ecounterService.stateService.currentEncounter | async)?.status !== 'in-progress' &&
                (ecounterService.stateService.currentEncounter | async)?.status !== 'planned' &&
                (ecounterService.stateService.currentEncounter | async)?.status !== 'triaged' )){

                <a mat-flat-button extended matTooltip="Add a new encounter for this patient" aria-label="Add Encounter"
                    style="z-index: 9999999999999999999;" tabindex="0" class="add-encounter" (click)="addEncounter()">
                    <mat-icon>add</mat-icon>
                    <span>Add Encounter</span>
                </a>
                }
                
                @if((ecounterService.stateService.currentEncounter | async)?.status === 'triaged'){
                <a mat-flat-button extended matTooltip="Resume this consultation" aria-label="Resume Consultation"
                    style="z-index: 9999999999999999999;" tabindex="0" class="add-encounter" color="accent" (click)="resumeConsultation()">
                    <mat-icon>play_arrow</mat-icon>
                    <span>Resume Consultation</span>
                </a>
                }
                
                @if((ecounterService.stateService.currentEncounter | async)?.status === 'in-progress' || (ecounterService.stateService.currentEncounter | async)?.status === 'planned'){
                <mat-menu #activities="matMenu" style="z-index: 9999999999999999999;">
                    <a (click)="showEncounterSheet()" mat-menu-item>
                        <mat-icon>visibility</mat-icon>
                        <span>Show Encounter Progress</span>
                    </a>

                    <a (click)="addPatientReportedSymptoms()" mat-menu-item>
                        <mat-icon>add</mat-icon>
                        <span>Add Patient Reported Symptoms</span>
                    </a>

                    <a (click)="addExamObservation()" mat-menu-item>
                        <mat-icon>add</mat-icon>
                        <span>Add Exam. Observation</span>
                    </a>
                    <a (click)="addVitals()" mat-menu-item>
                        <mat-icon>add</mat-icon>
                        <span>Add Vitals</span>
                    </a>

                    @if ((auth.user | async)?.role !== 'healthcareassistant') {
                    <a (click)="ecounterService.addDiagnosisV2()" mat-menu-item>
                        <mat-icon>add</mat-icon>
                        <span>Add Diagnosis</span>
                    </a>
                    }
                    @if ((auth.user | async)?.role !== 'healthcareassistant' && ((auth.user | async)?.role !== 'alliedhealthprofessional' || canPrescribeMedications)) {
                    <a (click)="ecounterService.addMedicationRequest(patientId)" mat-menu-item>
                        <mat-icon>add</mat-icon>
                        <span>Add Medication Request</span>
                    </a>
                    }
                    @if ((auth.user | async)?.role !== 'alliedhealthprofessional' || canOrderLab) {
                    <a (click)="ecounterService.addServiceRequest(patientId, 'Laboratory');" mat-menu-item>
                        <mat-icon>add</mat-icon>
                        <span>Order Lab Test</span>
                    </a>
                    }
                    <!-- <a (click)="ecounterService.addAllergy(patientId)" mat-menu-item>
                        <mat-icon>add</mat-icon>
                        <span>Add Allergy</span>
                    </a> -->

                    <a mat-menu-item (click)="changeEncounterStatus('finished')">
                        <div class="menu-trigger">
                            <mat-icon>check_circle</mat-icon>
                            <span>Change Encounter to Completed</span>
                        </div>
                    </a>
                    <!--
                    <a (click)="completeEncounter()" mat-menu-item [matMenuTriggerFor]="encounterM">
                        <div class="menu-trigger">
                            <mat-icon>add</mat-icon>
                            <span>Change Encounter Status</span>
                        </div>
                        <mat-menu #encounterM="matMenu">
                            <a mat-menu-item (click)="changeEncounterStatus('on-hold')">
                                Change Encounter to "On-Hold"
                            </a>
                            <a mat-menu-item (click)="changeEncounterStatus('finished')">Change Encounter to
                                "Completed"</a>
                            <a mat-menu-item (click)="confirmCancelButKeep('cancelled')">
                                Cancel Encounter But Keep Related Resources</a>

                            <a mat-menu-item (click)="confirmCancelAll('cancelled')">
                                Cancel Encounter And All Related Resources</a>


                        </mat-menu>

                    </a>
                    -->
                </mat-menu>

                <a mat-flat-button class="round-circle 
    g-just-flex
    " style="z-index: 9999999999999999999;" [matMenuTriggerFor]="activities">


                    Tasks
                    <mat-icon>chevron_right</mat-icon>
                </a>
                }
                }
                }
            </mat-tab-nav-panel>
        </div>
    </div>
</div>

<ng-template #topactions>
    <div class="top-actions-links-wrapper">

        <!-- <a mat-flat-button 
        [routerLink]="['/app/patients', patientId, 'admission', {action: 'add'}]"
            class="top-actions-link" routerLinkActive="router-link-active"> -->
        <a mat-flat-button role="button" [disabled]="(isPatientAdmitted$ | async)"
            (click)="admissionService.addAddmissionForm()" class="top-actions-link">
            <mat-icon>bed</mat-icon>
            <span> Admit Patient</span>
            @if((isPatientAdmitted$ | async)) {
            <span matBadge="Admitted" matBadgeColor="primary" matBadgeSize="small" style="margin-left: 8px;"></span>
            }
        </a>
        <!-- <a mat-flat-button role="button" [disabled]="(isPatientAdmitted$ | async)"
            (click)="admissionService.addAddmissionForm()" class="top-actions-link">
            <mat-icon>bed</mat-icon>
            <span> Admit Patient</span>

        </a> -->

        <a mat-flat-button role="button" class="top-actions-link" (click)="showBooking();">
            <mat-icon>chat</mat-icon>
            <span> Consult</span>
        </a>

        <!-- <a mat-flat-button role="button" class="top-actions-link" [routerLink]="['/tasks']">
            <mat-icon>task</mat-icon>
            <span> Tasks</span>
        </a> -->

        <a aria-label="More actions" [mat-menu-trigger-for]="topActionOtherLinks" role="button"
            class="top-actions-link more">

            <mat-icon>
                more_horiz
            </mat-icon>
        </a>
        <!--mat menu for other links-->
        <mat-menu #topActionOtherLinks>
            <a mat-menu-item (click)="referPatient()">



                <span>Refer</span>
            </a>

        </mat-menu>
    </div>
</ng-template>
}@else {
<app-patient-admission-wrapper>

</app-patient-admission-wrapper>
}
}@else {
<router-outlet>

</router-outlet>
}
